export enum LcaXLValidationErrorCode {
  OUTDATED_TEMPLATE = 'outdated-template',
  INVALID_TEMPLATE = 'invalid-template',
  MISSING_REQUIRED_INDICATOR = 'missing-indicator',
  INVALID_MODULE_VALUE = 'invalid-indicator-value',
  NO_INDICATORS_PARSED = 'no-indicators-parsed',
  INVALID_MODULE_COLUMNS = 'invalid-module-columns',
  INVALID_OPTIONAL_INDICATOR_VALUES = 'invalid-optional-indicator-values',
  INVALID_VALUE_MAX_LENGTH = 'invalid-value-max-length',
}
